module.exports = "/images/search-icon.svg";